"use client";
import LyricsIcon from "@mui/icons-material/Lyrics";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import Link from "~/components/Link";
import { AnalyticsEvents } from "~/connectors/analyticsEvents";
import Hero from "./Hero";
import { ROTATE_INTERVAL } from "./RotatingWord";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

export default function HeroSection() {
  const [wordIndex, setWordIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setWordIndex((i) => i + 1);
    }, ROTATE_INTERVAL);
    return () => clearInterval(id);
  }, []);

  return (
    <>
      <Hero wordIndex={wordIndex} />
      <Box sx={{ mt: 8, textAlign: "center" }}>
        <Box sx={{ display: "inline-block", position: "relative" }}>
          {/* Refined Ripple Effect */}
          {[1, 2].map((i) => (
            <motion.div
              key={`${wordIndex}-${i}`} // Restarts on word change
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{
                scale: [0.8, 1.5],
                opacity: [0, 0.5, 0],
              }}
              transition={{
                duration: 2,
                delay: 1 + i * 0.4, // Staggered ripples
                ease: "easeOut",
              }}
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                x: "-50%",
                y: "-50%",
                width: "100%",
                height: "100%",
                borderRadius: "50px", // Match button shape better
                backgroundColor: "var(--mui-palette-primary-main)",
                filter: "blur(20px)",
                zIndex: 0,
              }}
            />
          ))}

          <Link
            href="/comanda"
            trackable={AnalyticsEvents.HERO_CTA_CLICK}
            style={{ textDecoration: "none", position: "relative", zIndex: 1 }}
          >
            <motion.div
              key={wordIndex}
              animate={{ scale: [1, 1.03, 1] }}
              transition={{ duration: 0.4, delay: 1.8 }}
            >
              <Button
                id="main-cta-create"
                variant="contained"
                color="primary"
                size="large"
                startIcon={<LyricsIcon />}
                sx={{
                  px: 4,
                  py: 1.5,
                  borderRadius: "50px", // More modern pill shape
                  boxShadow: `0 4px 20px var(--mui-palette-primary-main)44`,
                }}
              >
                Creează
              </Button>
            </motion.div>
          </Link>
        </Box>
      </Box>
    </>
  );
}
